module.exports = __webpack_public_path__ + "img/ehic_ghic_info.f4a1e9a3.jpg";